import ufeApi from 'services/api/ufeApi';

const SDN_BASE_PATH = '/gway/v1/social-proof';

export const getSocialProof = (productId, locale = 'en-US') => {
    const url = `${SDN_BASE_PATH}/${encodeURIComponent(productId)}?locale=${encodeURIComponent(locale)}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).catch(error => {
        Sephora.logger.error('Social proof fetch failed', { productId, error });

        return null;
    });
};
